import FeedbackFlow from "@/modules/feedback/components/feedback-flow";

const APP_NAME = "Say About Us";

export default function FeedbackPage() {
	return <FeedbackFlow appName={APP_NAME} />;
}
